// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// Make sure App.css or index.css (where you imported form-js.css) is imported
import './App.css';

import { AuthProvider } from './context/AuthContext';
import App from './App'; // Ensure this imports YOUR App component from ./App.jsx


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider> {/* Wrap */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);